

export const setUserTokenToStorage = ({isLoggedIn,token}) => {
  localStorage.setItem('user',JSON.stringify( {
    isLoggedIn,
    token
  }));
};
export const setUserToStorage = (user)=>{
  localStorage.setItem('user',JSON.stringify( {
    isLoggedIn:true,
    ...user,
  }));

}
export const getUserTokenFromStorage = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : {};
};

export const deleteUserFromLocalStorage = () => {
  localStorage.removeItem('user');
};
